'use client';

import type { Nullable } from '@libs/core';
import { createContext, useMemo } from 'react';
import type { ContentfulBuildContextProps } from './types';

export const BuildContext = createContext<Nullable<ContentfulBuildContextProps>>(undefined);

export function BuildContextProvider({ pageId, children }: ContentfulBuildContextProps) {
    const values = useMemo(() => ({ pageId }), [pageId]);
    return <BuildContext.Provider value={values}>{children}</BuildContext.Provider>;
}
